import type { Quote } from '@client/model/quotesModel';
import { getQuotePaymentOption } from '@shared';

export type PaymentOption = 'Single Pay' | '5-Pay' | '10-Pay' | 'Monthly' | 'Annually';

// Deliberately the COARSE bucket, not the exact term: callers group quotes into
// these four fixed buckets (payment tabs, payment-type filters), so a '20-Pay'
// value would land in no bucket and silently drop the quote. Use
// getQuotePaymentOptionDisplayLabel where an exact term should be shown.
export function getPaymentOptionFromQuote(quote: Quote): PaymentOption {
  return getQuotePaymentOption(quote) ?? 'Single Pay';
}
